export default ({request}) => ({
    masterGoodsInputStandardListApi(data = {}) {
      return request({
        url: '/master/goods/input/standard/list',
        method: 'post',
        data,
      })
    },
    masterGoodsInputStandardDetailApi(data = {}) {
      return request({
        url: '/master/goods/input/standard/detail',
        method: 'post',
        data,
      })
    },
    masterGoodsInputStandardSaveApi(data = {}) {
      return request({
        url: '/master/goods/input/standard/save',
        method: 'post',
        data,
      })
    },
    masterGoodsInputStandardDelApi(data = {}) {
      return request({
        url: '/master/goods/input/standard/del',
        method: 'post',
        data,
      })
    },
  })
  